import { ReactNode, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  styled,
  Typography,
} from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";

interface Props {
  title: string;
  children: ReactNode;
}

export function LayerSetAccordion(props: Props) {
  const { title, children } = props;
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  function toggleAccordion() {
    setIsExpanded((prev) => {
      return !prev;
    });
  }

  return (
    <StyledAccordion
      elevation={0}
      disableGutters
      onChange={toggleAccordion}
      expanded={isExpanded}
    >
      <AccordionSummary expandIcon={<KeyboardArrowRight color="inherit" />}>
        <Typography variant="subtitle1">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </StyledAccordion>
  );
}

const StyledAccordion = styled(Accordion)`
  .MuiAccordionDetails-root {
    min-height: ${({ theme }) => theme.spacing(4)};
    display: flex;
    padding-top: 0;
    padding-bottom: 8px;
    flex-direction: column;
  }
  &.MuiAccordion-root::before {
    visibility: hidden;
  }
  &.MuiAccordion-root {
    background-color: transparent;
    border-bottom: 1px solid ${({ theme }) => theme.palette.grey[300]};
  }

  .MuiAccordionSummary-expandIconWrapper {
    transition: transform 320ms ease-out;
    .MuiSvgIcon-root {
      color: ${({ theme }) => theme.palette.common.black};
    }
    &.Mui-expanded {
      transform: rotate(90deg);
    }
  }

  .MuiAccordionSummary-root {
    padding: 0;
    flex-direction: row-reverse;
  }
`;
